import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-no-access',
    template: `
    <div
      class="text-center mt-3 mx-auto p-4"
      style="background: rgba(255,255,255,0.9); width: 400px;"
    >
      <h1><i class="fas fa-exclamation-circle"></i></h1>
      <h2>Access Denied</h2>
      <h3>Check your network connection</h3>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoAccessComponent {}
